/**
 * HTTP Utility
 *
 * Provides authenticated fetch for API calls.
 * Used by beaconApi service layer.
 */
import { getToken } from 'src/auth';

/**
 * Promise-based fetch with auth — for use with createAsyncThunk.
 * Adds Bearer token from session, returns parsed JSON or throws on error.
 */
export const fetchAsync = async <T = any>(url: string, method: 'GET' | 'POST' = 'GET', body?: string): Promise<T> => {
  const token = getToken();
  const headers: Record<string, string> = {
    Accept: 'application/json',
  };
  if (method === 'POST') {
    headers['Content-Type'] = 'application/json';
  }
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const res = await fetch(url, { method, headers, body });
  if (!res.ok) {
    const errorBody = await res.json().catch(() => null);
    throw new Error(errorBody?.message || `API error: ${res.status}`);
  }
  const json = await res.json();
  return json.data ?? json;
};
